var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-col',{staticClass:"ml-auto mr-auto",attrs:{"cols":"9","sm":"6","md":"4"}},[_c('v-card',{staticClass:"elevation-2 px-5 rounded-lg py-7 mt-10"},[_c('login-form')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }